// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9mNaz","breadcrumb":"styles_breadcrumb__CA_k8"};